import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { authActions } from "../../redux/store";
import toast from "react-hot-toast";
import TokenValidator from "../../fetchdata/TokenValidator";
import Cart from "./Cart";
import logo from "../assets_user/img/logo/ecomm-logo.svg"; // Import the logo image
import { useBlogContext } from "../../fetchdata/BlogContext";
import $ from "jquery";
import { Helmet } from "react-helmet";

import getCookie from "../../helper/getCookie";
import eraseCookie from "../../helper/eraseCookie";
import CreateSlug from "./extra/CreateSlug";

import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import GooglePlaceSelect from "./GooglePlaceSelect";



const MenuItem = ({ item }) => {
  return (
    <li key={item.id} className={item.children ? "has_submenu" : ""}>
      {item.children && item.children.length > 0 ? (
        <>
          <span>
            <Link
              to={item.link}
              target={item.target === "_blank" ? "_blank" : ""}
            >
              {item.text}
            </Link>
            <i class="ri-arrow-right-s-line"></i>
          </span>
          <SubMenu items={item.children} />
        </>
      ) : (
        <Link to={item.link} target={item.target === "_blank" ? "_blank" : ""}>
      <div dangerouslySetInnerHTML={{ __html: item.text }} className="mymobmenu" />
 
        </Link>
      )}
    </li>
  );
};

const SubMenu = ({ items }) => {
  return (
    <ul className="submenu">
      <li>
        <span className="mobile_menu_back">
          <i class="ri-arrow-left-line"></i> Back
        </span>
      </li>
      {items.map((child) => (
        <MenuItem key={child.id} item={child} />
      ))}
    </ul>
  );
};

const Header = () => {

    const phrases = ["Search here . . .", "Type your query . . .", "What are you looking for?"];
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [placeholder, setPlaceholder] = useState("");

  
   useEffect(() => {
    const currentPhrase = phrases[phraseIndex];

    const timeout = setTimeout(() => {
      if (charIndex < currentPhrase.length) {
        setPlaceholder((prev) => prev + currentPhrase[charIndex]);
        setCharIndex((prev) => prev + 1);
      } else {
        // Wait, then go to next phrase
        setTimeout(() => {
          setCharIndex(0);
          setPlaceholder("");
          setPhraseIndex((prev) => (prev + 1) % phrases.length);
        }, 2000); // Pause before switching
      }
    }, 100); // Typing speed

    return () => clearTimeout(timeout);
  }, [charIndex, phraseIndex, phrases]);
  

    const {
    transcript,
     resetTranscript,
    browserSupportsSpeechRecognition
  } = useSpeechRecognition();

  if (!browserSupportsSpeechRecognition) {
    toast.error(`Browser doesn't support speech recognition.`)
  }

   const [listening, setListening] = useState(false);

 const voiceSearch = () => {  
    if (!listening) {
        // Play welcome audio
      const welcomeAudio = new Audio('/assets/audio/search.mp3'); // Path to your audio file
      welcomeAudio.playbackRate = 1.2; // Set playback speed to 2x

      welcomeAudio.onended = () => {
        // Start listening after audio finishes
        SpeechRecognition.startListening({ continuous: false });
        setListening(true);
      };

      welcomeAudio.play();

      resetTranscript();
      SpeechRecognition.startListening({ continuous: false });
    } else {
      SpeechRecognition.stopListening();
    }
    setListening(!listening);
  };


  const navigate = useNavigate();

  // if (navigator.geolocation) {
  //   navigator.geolocation.getCurrentPosition(
  //     function (position) {
  //       const latitude = position.coords.latitude;
  //       const longitude = position.coords.longitude;
  
  //       // Save to localStorage
  //       localStorage.setItem("userLatitude", latitude);
  //       localStorage.setItem("userLongitude", longitude);
  
  //       console.log("Location saved");
  //     },
  //     function (error) {
  //       console.error("Location error:", error);
  //     }
  //   );
  // }

  
  useEffect(() => {
    if (navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (position) {
            const { latitude, longitude } = position.coords;

            localStorage.setItem("userLatitude", latitude);
            localStorage.setItem("userLongitude", longitude);

            console.log("Location saved:", latitude, longitude);

            // Optional: navigate after location is saved
            // navigate("/your-route");
          }
        },
        (error) => {
          // console.error("Location error:", error);

          switch (error.code) {
            case error.PERMISSION_DENIED:
              console.log("Permission denied. Please allow location access.");
              break;
            case error.POSITION_UNAVAILABLE:
              console.log("Location unavailable.");
              break;
            case error.TIMEOUT:
              console.log("Location request timed out.");
              break;
            default:
              // console.log("An unknown error occurred.");
          }
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    } else {
      console.log("Geolocation is not supported by your browser.");
    }
  }, []); // 🔁 Runs only once after first render

  
     const driverObj = driver({
      showProgress: true,
      theme: 'yellow',  // Set the theme to yellow
      steps: [
        { element: '#tour-example', popover: { title: 'Select Location', description: 'Please choose your location to proceed.', side: "left", align: 'start' }},
       
      ]
    });
  

     const initialFilterData = {};
  

  const [filterInputs, setFilterInputs] = useState(initialFilterData);


const handleLocationChange = (selected) => {
  console.log('myselected',selected)
  setFilterInputs({
    location: selected?.label || "",
    placeId: selected?.value || "",
    state: selected?.state || "",
    city: selected?.city || "",
    label: selected?.label || "",
    lat: selected?.lat || "",
    lng: selected?.lng || "",
  });
};


    useEffect(() => {
     
      if(!initialFilterData){
       driverObj.drive();

      }
     }, []);
  
     
      useEffect(() => {
if(transcript){
setsearchInputQuery(transcript);
} 
     }, [transcript]);

  
  const location = useLocation();

  const [user, setUser] = useState(null);

  const [showSearch, setShowSearch] = useState("false");
  const toggleSearch = () => {
    setShowSearch(!showSearch);
  };


  const {
    Headers,
    isHeader,
    cartItems,
    AllProducts,
    AllCategoriess,
    isLayoutLoading,
    LocationHeaders,
    layout,
  } = useBlogContext();
  if (isHeader) {
    // console.log("Headers", Headers);
  }

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const toggleSubMenu = (event) => {
    const submenu = event.target.nextElementSibling;
    submenu.classList.toggle("open");
  };

  const goBack = (event) => {
    const parentSubMenu = event.target.closest(".submenu");
    parentSubMenu.classList.remove("open");
  };


  useEffect(() => {
    $("#mobile_menu_container").removeClass("open");
    const storedUser = JSON.parse(getCookie("user"));
    setUser(storedUser);
  }, [location.pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);

    $("#mobile_menu_trigger").click(function () {
      $("#mobile_menu_container").toggleClass("open");
    });

    $("#mobile_menu_trigger_mob").click(function () {
      $("#mobile_menu_container").toggleClass("open");
    });

    $("#mobile_menu_container, .mobile_menu_close, .mobile_menu_close i").on(
      "click",
      function (e) {
        if (e.target === this) {
          $("#mobile_menu_container").toggleClass("open");
          /* $('#mobile_menu_container_inner').toggleClass('open'); */
        }
      }
    );

    $(document).on("click", "#mobile_menu .has_submenu > span", function () {
      $("+ .submenu", $(this)).addClass("open");
    });

    $(document).on("click", "#mobile_menu .sub_sub_menu > span", function () {
      $("+ ul", $(this)).addClass("open");
    });

    $(document).on("click", "#mobile_menu .mobile_menu_back", function () {
      $(this).closest("ul").removeClass("open");
    });
  }, []);

  const [searchQuery, setSearchQuery] = useState("");
  
  const [searchInputQuery, setsearchInputQuery] = useState("");

 

   const handleSearchInputChange = (e) => {
    setsearchInputQuery(e.target.value);
  };

  
  const handleSearchClearClick = () => {
    setsearchInputQuery("");
  };

const filteredProducts = AllProducts?.filter((item) =>
  item.title.toLowerCase().includes(searchInputQuery.toLowerCase())
);

const filteredCategories = AllCategoriess.filter((category) =>
  category.title.toLowerCase().includes(searchInputQuery.toLowerCase())
);

  const handleNavigateProductSearch = () => {
        const locationData = localStorage.getItem('location');
  
        if(locationData && locationData !== '[object Object]'){
          const search = `/shop-list/${searchInputQuery} in  ${locationData}?page=1&limit=12&sort=relevance`
       navigate(search)
    }else{
   toast.error("Please Choose Location First");
     }

  }


  const handleNavigateSellerSearch = () => {
            const locationData = localStorage.getItem('location');
 
                 if(locationData && locationData !== '[object Object]'){
 const search = `/seller-list/${searchInputQuery} in ${locationData}?page=1&limit=12&sort=relevance`
navigate(search)
    }else{
   toast.error("Please Choose Location First");
     }

 

  }


  const [SearchShow, setSearchShow] = useState(false);
  const handleFocus = () => {
    setSearchShow(true); // Update state when input is focused
  };
  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
    console.log('e.target.value',e.target.value);
  };

  const handleClearClick = (value) => {
     
  if(value){
      localStorage.setItem('location', value);
    }
    
    const locationData = localStorage.getItem('location');
const locSlug = locationData ? CreateSlug(locationData) : null;

    const currentPath = location.pathname; // e.g., /delhi/anypage
    const pathSegments = currentPath.split('/');
   
    const locLiveSlug = pathSegments.find(segment => segment.trim()); // finds "gumia"
    const cleanLocLiveSlug = locLiveSlug?.trim(); // final cleaned slug
    
console.log('currentPath locSlug ', cleanLocLiveSlug , locSlug ,value)
    if(cleanLocLiveSlug === locSlug &&  (!Array.isArray(value) && typeof value !== 'object' || value === null) ){

      //  Replace the first segment if it's a location
    if (pathSegments.length > 1) {
      pathSegments[1] = CreateSlug(value.toLowerCase()); // set new location
    }
    const updatedPath = pathSegments.join('/');
    console.log('livepath ', updatedPath )

    //  window.location.href = updatedPath;
    navigate(updatedPath)

    }else{
      const fvalue = CreateSlug(value);
      
      // if( fvalue == 'object-object'){
      //   navigate(`/`)
      // }else{
      //   navigate(`/${CreateSlug(value)}`)
      // }
    }
 

    setSearchQuery("");
    setSearchShow(false);

    setIsMenuSearch(false);

    //  if(value){
    //   localStorage.setItem('location', value);
    // }
  };
  



  // const filteredLocations = LocationHeaders.filter((zone) => {
  //   // Check if the state name or any of its cities contains the search query
  //   return (
  //     zone.name.toLowerCase().includes(searchQuery.toLowerCase())
  //   );
  // });

  const filteredLocations = LocationHeaders.filter((location) =>
    location.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsStuck(true);
      } else {
        setIsStuck(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures that this effect runs only once after initial render

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle the value of isMenuOpen
  };

  
const [isMenuSearch, setIsMenuSearch] = useState(false);

const toggleLocationMenu = () => {
  setIsMenuSearch(prev => !prev);
};

const CloseLocationMenu = () => {
  setTimeout(() => {
    setIsMenuSearch(false);
    setSearchQuery('');
  }, 100); // 1000 milliseconds = 1 second
};


  // const isLogin = useSelector(state => state.isLogin)
  // console.log(isLogin)

  const dispatch = useDispatch();
  //state
  const [value, setValue] = useState();

  // const isLoginFromLocalStorage = localStorage.getItem("token") ? true : false;
  const isLoginFromLocalStorage = getCookie("token") ? true : false;
  const [isLogin, setIsLogin] = useState(isLoginFromLocalStorage);

  useEffect(() => {
    setIsLogin(isLoginFromLocalStorage);
  }, [isLoginFromLocalStorage]);

  //logout
  const handleLogout = () => {
    try {
      dispatch(authActions.logout());
      toast.success("Logout Successfully");
      navigate("/login");
      localStorage.clear();
      eraseCookie("token");
      eraseCookie("userId");
      eraseCookie("user");
      //  localStorage.removeItem("token");
      // localStorage.removeItem("userId");
      // localStorage.removeItem("user");
    } catch (error) {
      console.log(error);
    }
  };
  const [isCartActive, setCartIsActive] = useState(false);

  const toggleCartClass = () => {
    setCartIsActive(!isCartActive);
  };

const GetCurrentLocation = () => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        const geocoder = new window.google.maps.Geocoder();
        const latlng = { lat: latitude, lng: longitude };

        geocoder.geocode({ location: latlng }, (results, status) => {
          if (status === "OK" && results[0]) {
            const addressComponents = results[0].address_components;

            // Extract area (e.g. locality or sublocality)
            const area = addressComponents.find((comp) =>
              comp.types.includes("sublocality_level_1") ||
              comp.types.includes("locality")
            )?.long_name;

            // Extract state
            const state = addressComponents.find((comp) =>
              comp.types.includes("administrative_area_level_1")
            )?.long_name;

            // Optional: Full formatted address
            const fullAddress = results[0].formatted_address;

            console.log("Area:", area);
            console.log("State:", state);
            console.log("Full address:", fullAddress);

            // Store values in localStorage
            // localStorage.setItem("location", fullAddress);
            // localStorage.setItem("area", area || "");
            // localStorage.setItem("state", state || "");

             localStorage.setItem("location", `${area || ""}, ${state || ""}`);


            // Update input or UI
            setSearchQuery(`${area || ""}, ${state || ""}`);
          } else {
            console.error("Geocoder failed:", status);
            // console.log("Could not get address from coordinates.");
          }
        });
      },
      (error) => {
        console.error("Geolocation error:", error);
        // console.log("Unable to retrieve your location.");
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  } else {
    // console.log("Geolocation is not supported by this browser.");
  }
  toggleLocationMenu();
};


  return (
    <>
      <TokenValidator />

      <Helmet>
        {Headers && Headers.meta_favicon && (
          <link rel="apple-touch-icon" href={Headers.meta_favicon} />
        )}
        {Headers && Headers.meta_title && <title>{Headers.meta_title}</title>}
        {Headers && Headers.head && (
          <React.Fragment
            dangerouslySetInnerHTML={{ __html: Headers.meta_head }}
          />
        )}
      </Helmet>

      <>
        {/* Header */}
        <header className="navigation shadow-sm border-bottom">
          {/* Topbar */}

          {/* Topbar */}
          {/* Navbar Sticky */}

          <div
            className={isStuck ? "navbar-sticky navbar-stuck" : "navbar-sticky"}
          >
            {/* <div
              className={` p-1 text-center text-white p ${layout.top_bar === "" && "d-none"
                }`}
              style={{ backgroundColor: "#6e110a", fontSize: "15px" }}
            >
       
              {layout.top_bar ? layout.top_bar : 'FLAT ₹200 OFF on 1st Enquire | Enquire Now'}{" "}
            </div> */}

            {/* {!isLayoutLoading ? (
              <div
                className={` p-1 text-center text-white p ${layout.top_bar === "" && "d-none"
                  }`}
                style={{ backgroundColor: "#fb5f50", fontSize: "15px" }}
              >
                {" "}
                {layout.top_bar ? layout.top_bar : 'FLAT ₹200 OFF on 1st Enquire | Enquire Now'}{" "}
              </div>
            ) : (
              <div
                className="card-1 skeleton"
                style={{
                  borderRadius: 5,
                  aspectRatio: "142/25",
                  width: "100%",
                  height: 30,
                }}
              ></div>
            )} */}

            {/* Navbar */}
            <div className="navbar navbar-middle navbar-expand-lg">
              <div className="container">
                {/* Logo */}
                <Link
                  className="navbar-brand flex-shrink-0 flex-fill "
                  to="/"
                  style={{ borderRadius: 5, aspectRatio: "100/25", height: 50 ,maxWidth:'fit-content'}}
                >
                  {Headers.meta_logo && Headers.meta_logo !== undefined ? (
                    <img
                      src={Headers.meta_logo}
                      width={120}
                      alt="logo"
                      style={{
                        maxHeight: 50,
                        width: "auto",
                        filter: "grayscale(0)",
                        mixBlendMode: "multiply",
                      }}
                    />
                  ) : (
                    <div
                      className="card-1 skeleton ms-2"
                      style={{
                        borderRadius: 5,
                        aspectRatio: "142/25",
                        width: "100%",
                        height: 50,
                      }}
                    ></div>
                  )}
                </Link>

                {/* Logo */}
                {/* Search */}

                <div
                  className={` d-none d-lg-flex me-5 w-100 custom-bg align-items-center border-0 rounded-pill ${!showSearch && "search-viewss" 
                    } `} 
                  style={{ backgroundColor: "#f3f7fb",maxWidth:'200px' }} id="tour-example"
                >
                  
                     <img src="/assets/img/google-maps.png"   style={{maxHeight:30,maxHeight:30}} className="bg-transparent ms-1"/>
 
                     
               <GooglePlaceSelect
                 className="border-0 w-100 custom-none-border"
                 value={
                   filterInputs?.placeId
                     ? {
                         label: filterInputs?.location,
                         value: filterInputs?.placeId,
                         city: filterInputs?.city,
                         state: filterInputs?.state,
                         lat: filterInputs?.latitude,
                         lng: filterInputs?.longitude,
                       }
                     : null
                 }
                 onChange={handleLocationChange}
               />
               

                        {/* {searchQuery &&
                          filteredLocations &&
                          filteredLocations.map((item) => {
                            console.log("item.slug", item.slug);
                            const myslug = CreateSlug(item.name); // Make sure `data` and `Product` are defined and available in the scope.
                            return (
                              <li key={item.id}>
                                <Link
                                  to={`/product/${myslug}`}
                                  onClick={handleClearClick}
                                >
                                  {" "}
                                  <i class="ri-shopping-bag-line"></i>{" "}
                                  {item.name}
                                </Link>
                              </li>
                            );
                          })}
                         */}

                      
                   

                  {(searchQuery ||SearchShow ) && (
                    <>
                      <button
                        type="button"
                        className="btn btn-primary bg-gradient d-none d-lg-block close"
                        onClick={handleClearClick}
                      >
                        {" "}
                        <i class="navbar-actions-icon ri-close-line fs-7"></i>{" "}
                      </button>
                    </>
                  )}
                </div>


        <div
                  className={`input-group d-none d-lg-flexx me-5 w-100 searchbox flex-fill ${!showSearch && "search-view" 
                    } `} 
                  style={{ backgroundColor: "#f3f7fb",maxWidth:'280px' }} id="tour-example"
                >
                 
  
                  <input
                    id="searchInput"
                    className="form-control searchinput"
                    type="text" 
                    placeholder={placeholder}
                    value={searchInputQuery  }
                    onChange={handleSearchInputChange}
                    onFocus={handleFocus} // Call handleFocus when the input is focused
                    autoComplete="off" // Disable browser suggestions
                     />
 
                         <button
                        type="button"
                        className="border-0 shadow-0 bg-white px-0 search-close"
                        onClick={handleSearchClearClick}
                      >
                        {" "}
                        <i class="navbar-actions-icon ri-close-line fs-7"></i>{" "}
                      </button>

                     <button
                    type="button"
                    onClick={voiceSearch}
                    className="btn bg-transparent rounded mic d-none d-lg-block search  text-white p-0 me-1" style={{background:'white'}}
                  >
                 {!listening ?
                 <img src="/assets/img/listme-mic.gif" width={16}  />
                 :
                <img src="/assets/img/voice.gif" width={16}  />

                 }
                  </button>


                  {/* <button
                    type="button"
                    onClick={handleNavigateProductSearch}
                    className="btn bg-transparent rounded d-none d-lg-block search  text-primary p-0 me-2" style={{background:'white'}}
                  >
                    
<i className="ri-search-eye-fill"/>
                
                  </button> */}
 {/* <img src="/assets/img/search-google.gif" width={30}/> */}
                  

                 {searchInputQuery && (
                    <>
                      <ul class="searchfloat">
 
                        {searchInputQuery &&
                          filteredProducts &&
                          filteredProducts.map((item) => {
                            console.log("item.slug", item.slug);
                            const myslug = CreateSlug(item.slug); // Make sure `data` and `Product` are defined and available in the scope.
                            return (
                              <li key={item.id}>
                                <a 
                                type="button"
                                onClick={()=>{
                                     
                                        navigate(`/product/${myslug}`)
                                       
                                }}
                                  >
                                  {" "}
                                  <i class="ri-shopping-bag-line"></i>{" "}
                                  {item.title}
                                </a>
                              </li>
                            );
                          })}
                        {searchInputQuery &&
                          filteredCategories &&
                          filteredCategories.map((item) => {
                                const locationData = localStorage.getItem('location');
const locSlug = locationData ? CreateSlug(locationData) : null;

                            return (
                              <li key={item.id}>
                                <a
                                type="button"
                                onClick={()=>{
                                      const locationData = localStorage.getItem('location');
                                      console.log('locationData',locationData)
                                      if(locationData && locationData !== '[object Object]'){
                                         navigate(`/${locSlug}/${item.slug}`)
                                      }else{
                                        toast.error('Please Select location first!')
                                      }
                                }}
                                   
                                >
                                  {" "}
                                  <i class="ri-list-check-2"></i> {item.title}
                                </a>
                              </li>
                            );
                          })}

      <li className="bg-white ">
                            {" "}
                            <p className="pt-1 px-3 text-dark">
                              <span onClick={handleNavigateSellerSearch} class="badge bg-primary fw-light mb-1 mt-2" type="button" ><i className="ri-flashlight-fill"></i> Looking for Seller</span>

                                <span onClick={handleNavigateProductSearch} class="badge bg-primary fw-light" type="button"  ><i className="ri-flashlight-fill"></i> Looking for product</span>

                            </p>{" "}
                          </li>
                          
                          

{/* 
                        {filteredProducts.length === 0 &&
                          filteredCategories.length === 0 ? (
                          <li className="bg-white ">
                            {" "}
                            <p className="pt-1 px-3 text-dark">
                              <span onClick={handleNavigateProductSearch} class="badge bg-primary fw-light mb-1 mt-2" type="button" ><i className="ri-flashlight-fill"></i> Looking for Seller</span>

                                <span onClick={handleNavigateProductSearch} class="badge bg-primary fw-light" type="button"  ><i className="ri-flashlight-fill"></i> Looking for product</span>

                            </p>{" "}
                          </li>
                        ) : null} */}

                      </ul>
                    </>
                  )}
     

                  {/* {(searchInputQuery ||SearchShow ) && (
                    <>
                      <button
                        type="button"
                        className="btn btn-primary bg-gradient d-none d-lg-block close"
                        onClick={handleSearchClearClick}
                      >
                        {" "}
                        <i class="navbar-actions-icon ri-close-line fs-7"></i>{" "}
                      </button>
                    </>
                  )} */}
                  
                </div>


                   <ul className="navbar-nav bg-transparent w-100 justify-content-start align-items-center d-md-flex d-none ">
                    <li className="nav-item " style={{ borderRadius:'0px',paddingRight:'15px'}}>
                      <Link
                        className="nav-link p-0"
                        id="mobile_menu_trigger"
                        to="#"
                        onClick={toggleMenu}
                      >
                    <i class="ri-apps-fill text-dark"></i> ALL
                      </Link>
                    </li>
                    
                    {isHeader
                      ? // Display loading skeletons while data is being fetched
                      Array.from({ length: 8 }).map((_, index) => (
                        <div className="nav-item" key={index}>
                          <div
                            className="skeleton mt-1 mx-3"
                            style={{
                              height: 22,
                              width: 100,
                              borderRadius: 5,
                            }}
                          ></div>
                        </div>
                      ))
                      : // Render first-level menu items
                      Headers.header !== undefined &&
                      Headers.header.slice(0, 5).map((item) => {
                        return (
                          <li className="nav-item" key={item.id}>
                            <Link
                              className={`nav-link ${item.children && item.children.length > 0
                                ? "dropdown-toggle"
                                : ""
                                }`}
                              to={
                                item.children && item.children.length > 0
                                  ? "#"
                                  : item.link
                              }
                              {...(item.children &&
                                item.children.length > 0 && {
                                "data-bs-toggle": "dropdown",
                              })}
                            >
                                              <div dangerouslySetInnerHTML={{ __html: item.text }} />

                              
                            </Link>

                            {item.children && item.children.length > 0 && (
                              <>
                                <div className="dropdown-menu p-0">
                                  <div className="row  px-4 py-4">
                                    {item.children
                                      .slice(0, 50)
                                      .map((child) => (
                                        <>
                                          {" "}
                                          <div className="col-md-3">
                                            {" "}
                                            <div className="widget widget-links mb-4">
                                              <h6 className="fs-base mb-3">
                                                {" "}
                                                <Link
                                                  className="widget-list-link"
                                                  to={child.link}
                                                  target={
                                                    child.target === "_blank"
                                                      ? "_blank"
                                                      : ""
                                                  }
                                                >
                                                  <b> {child.text} </b>
                                                </Link>
                                              </h6>
                                              <ul className="widget-list">
                                                {child.children
                                                  .slice(0, 20)
                                                  .map((child) => (
                                                    <li className="widget-list-item">
                                                      <Link
                                                        className="widget-list-link"
                                                        to={child.link}
                                                        target={
                                                          child.target ===
                                                            "_blank"
                                                            ? "_blank"
                                                            : ""
                                                        }
                                                      >
                                                        {child.text}
                                                      </Link>
                                                    </li>
                                                  ))}
                                              </ul>
                                            </div>{" "}
                                          </div>
                                        </>
                                      ))}
                                  </div>
                                </div>
                              </>
                            )}
                          </li>
                        );
                      })}
                  </ul>

                {/* Search */}
                {/* Navbar Actions */}
                <div className="navbar-actions flex-fill justify-content-end" style={{display:'contents'}}>
                  <Link
                    className="navbar-actions-item navbar-stuck-toggle d-none"
                    onClick={handleMenuToggle}
                  >
                    <div className="navbar-actions-icon-box">
                      {isMenuOpen ? (
                        <i className="navbar-actions-icon ri-close-line fs-7 text-secondary fw-bold" />
                      ) : (
                        <i className="navbar-actions-icon ri-menu-5-line fs-5 text-secondary fw-bold" />
                      )}
                    </div>
                  </Link>

                      <Link className=" align-items-center gap-2 d-md-none d-flex" to={'/cart'}>
        <i className="bi bi-bag" />
       </Link>
       
                  <Link
                    href="#"
                    className="navbar-actions-item d-lg-none"
                    id="mobile_menu_trigger_mob"
                  >
                    <div className="navbar-actions-icon-box">
                      {isMenuOpen ? (
                        <i className="navbar-actions-icon ri-close-line fs-7" />
                      ) : (
                        <i className="navbar-actions-icon ri-menu-line fs-5" />
                      )}
                    </div>
                  </Link>

                  <div className="">
                    {isLogin ? (
                      <>
                      
                        <div class="d-flex">
                          
                          <Link to="/account" className="navbar-actions-item">
                            <div className="navbar-actions-icon-box">
                              <i className="navbar-actions-icon ri-user-line fs-5" />
                            </div>
                            <div className="navbar-actions-text d-none d-lg-block fs-md pe-3 text-nowrap">
                              <small className="d-block mb-n1">
                                {" "}
                                {user &&
                                  user.username !== "" &&
                                  user.username !== undefined ? (
                                  user.username
                                ) : (
                                  <> Welcome, User </>
                                )}{" "}
                              </small>{" "}
                              <b className="text-primary"> My Account</b>
                            </div>
                          </Link>


                          <Link
                            onClick={handleLogout}
                            className="navbar-actions-item d-none"
                          >
                            <div className="navbar-actions-icon-box d-none d-md-flex">
                              <i class="navbar-actions-icon  ri-logout-box-r-line fs-5 text-danger" />
                            </div>
                            {/* <div className="navbar-actions-text d-none d-lg-block fs-md pe-3">
                              <small className="d-block mb-n1"> Account </small>{" "}
                              <b className="text-danger"> Logout</b>
                            </div> */}
                          </Link>
                        </div>
 
                      </>
                    ) : (
                      <>
                        <Link to="/login" className="navbar-actions-item">
                          <div className="navbar-actions-icon-box">
                            <i className="navbar-actions-icon ri-user-line fs-5" />
                          </div>
                          <div className="navbar-actions-text d-none d-lg-block fs-md pe-3">
                            <small className="d-block mb-n1">Login</small>{" "}
                            Account
                          </div>
                        </Link>
                      </>
                    )}
                  </div>
    <Link className="btn btn-success btn-cart  align-items-center gap-2 d-md-flex d-none" to={'/cart'}>
        <i className="bi bi-bag" />
        <span className="fw-semibold d-md-inline d-none"> {(cartItems && cartItems.length !== 0 ) ? `${cartItems.length} Items` : "My Cart"} </span>
      </Link>
      

             
                  <button
                    onClick={toggleSearch}
                    className="navbar-actions-item border-0 d-none"
                  >
                    <div className="navbar-actions-icon-box">
                      <i className="navbar-actions-icon ri-search-line fs-5" />
                    </div>
                  </button>
                </div>
                {/* Navbar Actions */}
              </div>
            </div>
            {/* Navbar */}
            {/* Navs */}

       

            <div
              className={`navbar navbar-expand-lg navbar-stuck-menu py-0 py-lg-1 bg-body-tertiary${isMenuOpen ? " show" : ""
                } center-line`}
            >
              <div className="container ">
                <div
                  className="collapse navbar-collapse show"
                  id="navbarCollapse"
                >
                  {/* Departments Menu */}
                  <ul className="navbar-nav mega-nav pe-lg-1 me-lg-1  mt-3 mt-lg-0 d-lg-none">
                    <div className="navbar-actions d-lg-none w-100 justify-content-between mb-2 bg-black p-3">
                      <a
                        href="account-login"
                        className="navbar-actions-item bg-black"
                        previewlistener="true"
                      >
                        <div className="navbar-actions-icon-box">
                          <i className="navbar-actions-icon ri-user-line fs-5" />
                        </div>
                        <div className="navbar-actions-text fs-md pe-3">
                          <small className="d-block mb-n1">Sign In</small>{" "}
                          Account
                        </div>
                      </a>

                      <Link
                        href="#"
                        className="navbar-actions-item d-lg-none bg-black"
                        onClick={handleMenuToggle}
                      >
                        <div className="navbar-actions-icon-box">
                          {isMenuOpen ? (
                            <i className="navbar-actions-icon ri-close-line fs-7" />
                          ) : (
                            <i className="navbar-actions-icon ri-menu-line fs-5" />
                          )}
                        </div>
                      </Link>
                    </div>

                    <li className="nav-item dropdown">
                      {/* <a
                  className="nav-link dropdown-toggle ps-lg-0"
                  href="#"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="outside"
                >
                  <i className="ri-function-line me-2" /> All Departments{" "}
                </a> */}
                    </li>
                  </ul>
                  {/* Departments Menu */}
                 
                </div>
              </div>
            </div>
            {/* Navs */}
          </div>
          
          {/* Navbar Sticky */}
        </header>

        <div id="mobile_menu_container" className="">
          <div id="mobile_menu_container_inner">
            <div className="mobile_menu_top">
              <Link to="/">
                {Headers.meta_logo && Headers.meta_logo !== undefined ? (
                  <img
                    src={Headers.meta_logo}
                    width={120}
                    alt="logo"
                    style={{ maxHeight: 50, width: "auto" }}
                  />
                ) : (
                  <div
                    className="card-1 skeleton"
                    style={{ borderRadius: 5, aspectRatio: "300/42" }}
                  ></div>
                )}
              </Link>
              <div className="mobile_menu_close">
                <i class="ri-close-line"></i>
              </div>
            </div>
            <div id="mobile_menu_image_links"></div>

            <ul id="mobile_menu">
              {Headers.header &&
                Headers.header.length > 0 &&
                Headers.header.map((item) => (
                  <MenuItem key={item.id} item={item} />
                ))}

             

              {isLogin ? (
                <>
                  <li className="has_submenu">
                    <Link to="/account">Account</Link>
                  </li>

                  <li className="has_submenu">
                    <Link to="/wishList">Wishlist</Link>
                  </li>

                  <li className="has_submenu">
                    <Link to="/comparsion">Comparsion</Link>
                  </li>

                  <li className="has_submenu">
                    <Link onClick={handleLogout}>Logout</Link>
                  </li>
                </>
              ) : (
                <>
                  <li className="has_submenu">
                    <Link to="/comparsion">Login / Signup</Link>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>

       

        {/* Header */}
      </>
    </>
  );
};

export default Header;
